import React from 'react'
import { Box, useTheme } from 'native-base'
import ConfigComponent from '../components/ConfigComponent'
import type { RootStackProps } from '../screens/Home'
import { NativeStackScreenProps } from '@react-navigation/native-stack'

type Props = NativeStackScreenProps<RootStackProps, 'HoursReport'>;

const Config = ({ navigation }: Props) => {
  const { colors } = useTheme()

  return (
    <Box style={{ backgroundColor: colors.primary[50] }}>
      <ConfigComponent navigation={navigation} />
    </Box>
  )
}

export default Config
